import React, { useContext, useEffect, useState } from 'react'
import { Container, Footer, InputContainer, Row, Title } from './styled'
import { Input } from '../../../../components/common/Input'
import { Select } from '../../../../components/common/Select'
import { Button } from '../../../../components/common/Button'
import { BaseContext } from '../../../../context/context_baseRegister'
import { Modal } from '../../../../components/Modal'
import { CheckCircle } from '@phosphor-icons/react'
import axios from 'axios'

export const NewBase = () => {
  const {
    handleFormSubmit,
    setFormData,
    formData,
    states,
    isFormDataValid,
    maskCEP,
  } = useContext(BaseContext)

  const [confirmNewBase, setConfirmNewBase] = useState<boolean>(false)
  const [registered, setRegistered] = useState<boolean>(false)

  const handleChangeCep = async (cep: string) => {
    try {
      if (cep.length >= 8) {
        const response = await axios.get(
          `https://viacep.com.br/ws/${cep}/json/`,
        )

        setFormData?.((prev: any) => ({
          ...prev,
          Address: [
            {
              address: response.data.logradouro || '',
              zipcode: response.data.cep || '',
              burgh: response.data.bairro || '',
              city: response.data.localidade || '',
              state: response.data.uf || '',
            },
          ],
        }))
      }
    } catch (error) {
      console.error('Erro na requisição:', error.message)
    }
  }

  const handleSubmit = (event) => {
    if (handleFormSubmit) {
      handleFormSubmit(event)
      setRegistered((prev) => !prev)
      setConfirmNewBase((prev) => !prev)
    } else {
      console.log('erro ao enviar')
    }
  }

  return (
    <>
      <Container
        onSubmit={(e) => {
          e.preventDefault()
          setConfirmNewBase((prev) => !prev)
        }}
      >
        <InputContainer>
          <Input.Root>
            <Input.Label
              title="Nome da base"
              htmlFor=""
              color=""
              fontSize="14px"
            />
            <Input.Wrapper
              borderColor="#CECECE"
              backgroundColor="#F7F7F7"
              outlineColor=""
            >
              <Input.Content
                id=""
                type="text"
                placeholder="Nome da base"
                onChange={(e) => {
                  setFormData?.((prev: any) => ({
                    ...prev,
                    base: e.target.value,
                  }))
                }}
                required
              />
            </Input.Wrapper>
          </Input.Root>
        </InputContainer>
        <InputContainer>
          <Input.Root>
            <Input.Label
              title="Nome do posto"
              htmlFor=""
              color=""
              fontSize="14px"
            />
            <Input.Wrapper
              borderColor="#CECECE"
              backgroundColor="#F7F7F7"
              outlineColor=""
            >
              <Input.Content
                id=""
                onChange={(e) => {
                  setFormData?.((prev: any) => ({
                    ...prev,
                    outpost: e.target.value,
                  }))
                }}
                type="text"
                placeholder="Nome do posto"
                required
              />
            </Input.Wrapper>
          </Input.Root>
        </InputContainer>

        <Title>Endereço</Title>
        <InputContainer>
          <Input.Root>
            <Input.Label title="CEP" htmlFor="" color="" fontSize="14px" />
            <Input.Wrapper
              borderColor="#CECECE"
              backgroundColor="#F7F7F7"
              outlineColor=""
            >
              <Input.Content
                id=""
                maxLength={9}
                value={formData?.Address[0].zipcode}
                onChange={(e) => {
                  const maskedValue = maskCEP(e.target.value)

                  setFormData?.((prev: any) => ({
                    ...prev,
                    Address: [
                      {
                        ...prev.Address[0],
                        zipcode: maskedValue,
                      },
                    ],
                  }))

                  handleChangeCep(e.target.value)
                }}
                type="text"
                placeholder="xxxxx-xxxx"
                required
              />
            </Input.Wrapper>
          </Input.Root>
        </InputContainer>

        <InputContainer>
          <Input.Root>
            <Input.Label title="Rua" htmlFor="" color="" fontSize="14px" />
            <Input.Wrapper
              borderColor="#CECECE"
              backgroundColor="#F7F7F7"
              outlineColor=""
            >
              <Input.Content
                id=""
                value={formData?.Address[0].address}
                onChange={(e) => {
                  setFormData?.((prev: any) => ({
                    ...prev,
                    Address: [
                      {
                        ...prev.Address[0],
                        address: e.target.value,
                      },
                    ],
                  }))
                }}
                type="text"
                placeholder="Rua"
                required
              />
            </Input.Wrapper>
          </Input.Root>
        </InputContainer>
        <InputContainer>
          <Input.Root>
            <Input.Label title="Bairro" htmlFor="" color="" fontSize="14px" />
            <Input.Wrapper
              borderColor="#CECECE"
              backgroundColor="#F7F7F7"
              outlineColor=""
            >
              <Input.Content
                id=""
                value={formData?.Address[0].burgh}
                onChange={(e) => {
                  setFormData?.((prev: any) => ({
                    ...prev,
                    Address: [
                      {
                        ...prev.Address[0],
                        burgh: e.target.value,
                      },
                    ],
                  }))
                }}
                placeholder="Bairro"
                type="text"
                required
              />
            </Input.Wrapper>
          </Input.Root>
        </InputContainer>
        <InputContainer>
          <Input.Root>
            <Input.Label title="Cidade" htmlFor="" color="" fontSize="14px" />
            <Input.Wrapper
              borderColor="#CECECE"
              backgroundColor="#F7F7F7"
              outlineColor=""
            >
              <Input.Content
                id=""
                value={formData?.Address[0].city}
                onChange={(e) => {
                  setFormData?.((prev: any) => ({
                    ...prev,
                    Address: [
                      {
                        ...prev.Address[0],
                        city: e.target.value,
                      },
                    ],
                  }))
                }}
                type="text"
                placeholder="Cidade"
                required
              />
            </Input.Wrapper>
          </Input.Root>
        </InputContainer>

        <Row>
          <InputContainer>
            <Select
              label={{
                title: 'Estado',
                htmlFor: '',
                color: '',
                fontSize: '14px',
              }}
              onchange={(e) => {
                setFormData?.((prev: any) => ({
                  ...prev,
                  Address: [
                    {
                      ...prev.Address[0],
                      state: e.target.value,
                    },
                  ],
                }))
              }}
              data={states}
              backgroundcolor=""
              bordercolor=""
              currentOption={formData?.Address[0].state}
              outlinecolor=""
            />
          </InputContainer>
        </Row>

        <Footer>
          <Button.Root backgroundColor="#00517D" type="submit">
            <Button.Content title="Cadastrar" color="#fff" />
          </Button.Root>
        </Footer>
      </Container>
      <Modal.Root
        backgroundcolor="#fff"
        borderradius="6px"
        width="fit-content"
        height="fit-content"
        left="50%"
        top="50%"
        open={confirmNewBase}
        setIsOpenController={() => setConfirmNewBase((prev) => !prev)}
      >
        <Modal.Header onclick={() => setConfirmNewBase((prev) => !prev)} />
        <Modal.Content
          value="Você está cadastrando uma nova base"
          subvalue="Ao clicar em salvar, você estará atualizando o banco de seleção do sistema."
        />
        <Modal.Footer>
          <Button.Root
            backgroundColor="#fff"
            border="1px solid #770A00"
            onClick={() => setConfirmNewBase((prev) => !prev)}
          >
            <Button.Content title="Não, cancelar" color="#770A00" />
          </Button.Root>
          <Button.Root backgroundColor="#00517D" onClick={handleSubmit}>
            <Button.Content title="Cadastrar" color="#fff" />
          </Button.Root>
        </Modal.Footer>
      </Modal.Root>

      <Modal.Root
        backgroundcolor="#fff"
        borderradius="6px"
        height="fit-content"
        width="25%"
        left="50%"
        top="50%"
        open={registered}
        setIsOpenController={() => location.reload()}
      >
        <Modal.Header onclick={() => setRegistered((prev) => !prev)} />
        <Modal.Icon icon={<CheckCircle size={60} color="#00517D" />} />
        <Modal.Content
          value="Dados atualizados!"
          subvalue="Ao acessar novamente as informações de bases, você verá as novas informações cadastradas."
        />
        <Modal.Footer>
          <Button.Root
            backgroundColor="#00517D"
            onClick={() => location.reload()}
          >
            <Button.Content title="Voltar para página" color="#fff" />
          </Button.Root>
        </Modal.Footer>
      </Modal.Root>
    </>
  )
}
